import { render, staticRenderFns } from "./EntityStatistics.vue?vue&type=template&id=4196a3bc"
import script from "./EntityStatistics.js?vue&type=script&lang=js&external"
export * from "./EntityStatistics.js?vue&type=script&lang=js&external"
import style0 from "./EntityStatistics.vue?vue&type=style&index=0&id=4196a3bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports